import { useAtomValue } from 'jotai';
import React, { useCallback, useEffect, useMemo } from 'react';
import styled from 'styled-components';

import { DefaultHeader } from '../../components/DefaultHeader';
import { SITE_LINKS } from '../../constants';
import { Environment } from '../../enum';
import { useEnvironment } from '../../hooks/use-environment';
import { userAtom } from '../../jotai-atoms/user.atom';

enum MessageType {
  HANDSHAKE = 'HANDSHAKE',
  ACTIVITIES = 'ACTIVITIES',
}

const PRE_CLASS_PLAYER_URL_STG =
  'https://junior-apps.stg.openenglish.com/pre-class-player/index.html';
const PRE_CLASS_PLAYER_URL = 'https://junior-apps.openenglish.com/pre-class-player/index.html';

export const PreClassActivityPage = () => {
  const user = useAtomValue(userAtom);
  const { environment } = useEnvironment();

  const playerUrl = useMemo(() => {
    if (environment === Environment.local || environment === Environment.stg) {
      return PRE_CLASS_PLAYER_URL_STG;
    }

    return PRE_CLASS_PLAYER_URL;
  }, [environment]);

  const handler = useCallback(
    (event: MessageEvent) => {
      const type = event.data?.type;
      if (type === MessageType.HANDSHAKE) {
        const iframeElement = document.getElementById('pre-class-player') as HTMLIFrameElement;
        const activities = user?.nextLiveClass?.preClassActivities?.map(({ url }) => url);
        iframeElement.contentWindow?.postMessage({ type: MessageType.ACTIVITIES, activities }, '*');
      }
    },
    [user],
  );

  const listen = useCallback(() => {
    window.addEventListener('message', handler);
  }, [handler]);

  const stopListening = useCallback(() => {
    window.removeEventListener('message', handler);
  }, [handler]);

  useEffect(() => {
    if (!user?.nextLiveClass?.preClassActivities?.length) {
      window.location.replace(SITE_LINKS.LevelsPage);
      return;
    }

    listen();

    return () => {
      stopListening();
    };
  }, [user]);

  return (
    <Container>
      <DefaultHeader />
      <StyledIFrame id="pre-class-player" title="Pre Class" src={playerUrl} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
`;

const StyledIFrame = styled.iframe`
  flex: 1;
`;
